import { useEffect } from "react";
import { Redirect, useLocation } from "wouter";
import { useQuery } from "@tanstack/react-query";
import NotFound from "@/pages/not-found";
import { Skeleton } from "@/components/ui/skeleton";
import { getAdminStatusOptions } from "@/services/queryOptions/authQueryOptions";
import { TweetoAdminLayout } from "./Layout";
import { OuraAdminPage } from "./oura";
import { PartnerManagementPage } from "./partners";
import { RbacAdminPage } from "./rbac";

export default function TweetoAdmin() {
  const [location, setLocation] = useLocation();
  const adminStatus = useQuery(getAdminStatusOptions());

  useEffect(() => {
    if (location === "/tweeto-admin" || location === "/tweeto-admin/") {
      setLocation("/tweeto-admin/oura/protocol", { replace: true });
    }
  }, [location, setLocation]);

  if (adminStatus.isLoading) {
    return (
      <div className="min-h-screen bg-zinc-950 p-6 text-white">
        <div className="space-y-4">
          <Skeleton className="h-10 w-64" />
          <Skeleton className="h-[520px] w-full" />
        </div>
      </div>
    );
  }

  if (adminStatus.isError || !adminStatus.data) {
    return <NotFound />;
  }

  if (location === "/tweeto-admin" || location === "/tweeto-admin/") {
    return <Redirect to="/tweeto-admin/oura/protocol" />;
  }

  return (
    <TweetoAdminLayout username={adminStatus.data.user.username}>
      {location.startsWith("/tweeto-admin/rbac") ? (
        <RbacAdminPage />
      ) : location.startsWith("/tweeto-admin/partners") ? (
        <PartnerManagementPage />
      ) : (
        <OuraAdminPage />
      )}
    </TweetoAdminLayout>
  );
}
